import { render, staticRenderFns } from "./jifen-detail.vue?vue&type=template&id=19e65033&"
import script from "./jifen-detail.vue?vue&type=script&lang=js&"
export * from "./jifen-detail.vue?vue&type=script&lang=js&"
import style0 from "./jifen-detail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports